import { Box, TextInput } from 'grommet';
import { FieldThumbnail } from '../../../../../components/FieldThumbnail';
import i18next, { t } from 'i18next';
import { StyledTooltip } from '../../../../../components/common/StyledTooltip';
import deleteIcon from '../../../../../assets/BoundaryTool/deleteIcon.svg';
import unenrollIcon from '../../../../../assets/BoundaryTool/unenroll-icon.svg';
import React from 'react';

export const ItemHeader = ({ field, saveField, handleDelete, producerData, handleUnenroll, userRegion, allowBoundaryEdit, disabledBtn }: any) => {
  const isVerification = !producerData?.caseStatusHistory?.find((s: any) => s.status === 'In Support') || userRegion === 'BR';

  const handleChange = (event: any) => {
    event.stopPropagation();
    saveField({ ...field, properties: { ...field.properties, name: event.target.value } });
  };

  const inputStyle = { lineHeight: '16px', padding: '6px', border: '1px solid #808080', borderRadius: '0', fontWeight: '800' };
  const unenrollBtn = { opacity: disabledBtn ? '0.5' : '1', marginLeft: '16px', cursor: disabledBtn ? 'default' : 'pointer' };

  const tooltipLabel = isVerification
    ? t(`${allowBoundaryEdit ? 'fieldFlow.mainWizard.Fields.deleteTooltip' : 'fieldFlow.drawingPanel.disabled'}`)
    : t(`fieldFlow.mainWizard.Fields.unenrollTooltip`);

  return (
    <Box direction={'row'} align={'center'} margin={{ top: '18px' }}>
      <FieldThumbnail feature={field} height={36} width={36} />
      <Box style={{ marginLeft: '8px' }} width={'43.4%'} height={'36px'}>
        <TextInput
          data-cy={`field-name-input-${field.id}`}
          plain
          focusIndicator={false}
          style={{ ...inputStyle, fontSize: '16px', height: '36px', flexGrow: '1.02' }}
          value={field.properties!['name'] ?? ''}
          onChange={handleChange}
        />
      </Box>
      <Box style={{ marginLeft: '16px' }} width={'42.8%'} height={'36px'}>
        <TextInput
          data-cy={`field-area-input-${field.id}`}
          plain
          focusIndicator={false}
          disabled={true}
          style={{ ...inputStyle, fontSize: '16px', height: '36px' }}
          value={Number(field.properties![i18next.language === 'pt-BR' ? 'areaHectare' : 'area']).toFixed(2) ?? ''}
        />
      </Box>
      <StyledTooltip label={tooltipLabel} showToolTip={isVerification ? disabledBtn : true} dropOptions={isVerification ? 'left' : 'top'}>
        <img
          data-cy={`${isVerification ? 'delete' : 'enrollment'}-field-button-${isVerification ? field.id : field?.properties?.name}`}
          src={isVerification ? deleteIcon : unenrollIcon}
          alt={`${isVerification ? 'Delete' : 'Unenrollment'} Icon`}
          style={{ ...unenrollBtn, width: '24px', height: '24px' }}
          onClick={isVerification ? handleDelete : handleUnenroll}
        />
      </StyledTooltip>
    </Box>
  );
};
